var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTreasureChest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M352 336C352 344.875 344.875 352 336 352H240C231.125 352 224 344.875 224 336V288H128V480H448V288H352V336ZM0 128V256H96V32C43 32 0 75 0 128ZM0 448C0 465.625 14.375 480 32 480H96V288H0V448ZM480 32V256H576V128C576 75 533 32 480 32ZM304 304V240C304 231.125 296.875 224 288 224S272 231.125 272 240V304C272 312.875 279.125 320 288 320S304 312.875 304 304ZM480 480H544C561.625 480 576 465.625 576 448V288H480V480ZM128 256H224V208C224 199.125 231.125 192 240 192H336C344.875 192 352 199.125 352 208V256H448V32H128V256Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreasureChest);
export default __webpack_public_path__ + "static/media/treasure-chest.74da1fad2481a04d06e4720530b3b65b.svg";
export { ForwardRef as ReactComponent };